import firebase from 'firebase/app';
import 'firebase/auth';

import firebaseToken from '../../firebase.json';
import AxiosInstance from './helpers/AxiosInstance';

const firebaseApp = firebase.initializeApp(firebaseToken);

export const auth = firebaseApp.auth();

export const getUserClaims = async () => {
  const tokenResult = await auth.currentUser?.getIdTokenResult();
  return tokenResult.claims;
};

export const refreshToken = async () => {
  if (auth.currentUser) {
    await auth.currentUser.getIdToken(true);
    const tokenId = await auth.currentUser.getIdTokenResult();
    const endPoint =
      tokenId.claims.role === 'super_admin'
        ? '/opu-user/'
        : tokenId.claims.role === 'admin'
        ? '/opu-user/update-profile/'
        : '/establishment-user/update-profile/';
    // AxiosInstance.patch('/opu-user/update-profile/' + tokenId.claims.id, {
    //   isVerified: true,
    // });
    AxiosInstance.patch(endPoint + tokenId.claims.id, {
      isVerified: true,
    });
  }
};

export default firebaseApp;
